<template>
    <div class="lg:w-1/2 m-auto">

        <setup-substep name="welcome-substep-1" next-text="Show me how" next-substep="welcome-substep-2" open>
            <p class="my-2 font-bold">Your inbox is your biggest time-suck.</p>
            
            <p class="my-2">📬 Mailman allows you to control what kind of emails can come in and when.</p>
        </setup-substep>

        <setup-substep name="welcome-substep-2" next-text="Setup Delivery →" @completed="done">
            <span class="border-t my-4 border-gray-dark block"></span>
            
            <p class="my-2">It collects and delivers all incoming emails in batches at <strong>your</strong> chosen times.</p>
            
            <!-- <p class="my-2">No more neverending stream of incoming emails throughout your day!</p> -->
            
            <span class="border-t my-4 border-gray-dark block"></span>

            <p class="mt-4 mb-2">Let's setup the delivery slots for your incoming emails.</p>
        </setup-substep>
    </div>
</template>

<script>
export default {
    id   : 'welcome',
    icon : 'glass-cheers',
    label: 'Welcome',
    
    methods: {
        done() {
            this.$emit('done');
        },
    }

}
</script>